import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon, Button } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { PhishingTemplateModal, PhishingTemplateDeleteModal } from 'components';

import { CtExamTemplateEdit, CtExamTemplateDelete, CtExamTemplateCopy, CtPhishingTemplateCopy } from 'containers';

import * as commonVar from 'libs/commonVar';

import classNames from 'classnames/bind';
import styles from './PhishingTemplateInTableMenu.css';
const cx = classNames.bind(styles);

class PhishingTemplateInTableMenu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      deleteModal: false,
      editModal: false,
      copyModal: false
    };
  }

  toggleDeleteModal = () => {
    this.setState({ deleteModal: !this.state.deleteModal });
  };

  toggleCopyModal = () => {
    this.setState({ copyModal: !this.state.copyModal });
  };

  toggleEditModal = e => {
    this.setState({ editModal: !this.state.editModal });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { deleteModal, copyModal, editModal } = this.state;
    const { isAuth, phishingInfo } = this.props;
    const { toggleDeleteModal, toggleCopyModal, toggleEditModal } = this;

    // isAuth : 1-사용자, 2-관리자
    // isSaas : 0-구축형, 1-서비스형
    // isPublic : 0-사용자, 1-기본
    return (
      <div className={'inline-conf-area'}>
        <Tooltip
          title={defineMessages(formatMessage({ id: 'ExamTemplateInTableMenu_1', defaultMessage: '템플릿 복제' }))}
          placement="bottom">
          <Icon color="grey" className={cx('icon-copy')} name="copy" link onClick={toggleCopyModal} />
        </Tooltip>
        {copyModal && (
          <CtPhishingTemplateCopy isAuth={isAuth} phishingInfo={phishingInfo} toggleCopyModal={toggleCopyModal} />
        )}
        {((commonVar.isSaas === 1 && isAuth === 2) || phishingInfo.isBasic === 0) &&
          <Tooltip
            title={defineMessages(formatMessage({ id: 'ExamTemplateInTableMenu_3', defaultMessage: '템플릿 수정' }))}
            placement="bottom">
            <Icon color="grey" className={cx('icon-edit')} name="edit" link onClick={toggleEditModal} />
          </Tooltip>}
        {editModal && (
          <PhishingTemplateModal isAuth={isAuth} config={{ mode: 'edit', phishingInfo }} toggleModal={toggleEditModal} />
        )}
        {(isAuth === 2 || phishingInfo.isBasic === 0) &&
          <Tooltip
            title={defineMessages(formatMessage({ id: 'ExamTemplateInTableMenu_4', defaultMessage: '템플릿 삭제' }))}
            placement="bottom">
            <Icon color="grey" className={cx('icon-remove')} name="remove circle" link onClick={toggleDeleteModal} />
          </Tooltip>}
        {deleteModal && (
          <PhishingTemplateDeleteModal isAuth={isAuth} phishingInfo={phishingInfo} toggleModal={toggleDeleteModal} />
        )}
      </div>
    );
  }
}

export default injectIntl(PhishingTemplateInTableMenu);



// WEBPACK FOOTER //
// ./src/script/components/phishingTemplate/PhishingTemplateInTableMenu.js